import { useFormContext, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Sheet } from '@calendly/ui/components/sheet';
import { LabelText } from '@calendly/ui/components/typography';
import { UiConfig } from '@calendly/ui/config';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef, useEffect } from 'react';
import { Layout } from 'components/layout';
import { MemberContent } from '../member_content';
import { AvailabilityCalendar } from './availability_calendar';
import { Footer } from './footer';
const viewContainerCss = "v167pvo9";
const ViewContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(viewContainerCss, props.className)} />;
});
const containerCss = "c1enbpil";
const Container = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <FixedContainer ref={ref} {...props} isPhone={isPhone} className={classNames(containerCss, props.className)} />;
});
const customSheetCss = "c1ytwbkn";
const CustomSheet = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(customSheetCss, props.className)} />);
const headerWrapperCss = "h11cy3hm";
const HeaderWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerWrapperCss, props.className)} />;
});
const HeaderLayout = ({
  children
}) => <Layout align="center">
    <LabelText size="large">{children}</LabelText>
  </Layout>;
const Header = props => <Layout paddingY="8" paddingX="16" align="center" justify="space-between" {...props} />;
const HeaderContent = ({
  formPath
}) => {
  const [{
    value: availability
  }] = useFormField({
    name: formPath
  });
  const {
    values: {
      name
    }
  } = useFormContext();
  const isMemberAvailability = Boolean(availability.userId || availability.organizationInvitationId);
  if (!isMemberAvailability) {
    return <HeaderLayout>
        {I18n.t('publisher.event_type_editor.sections.available_hours.date_overrides.event_type_availability', {
        name
      })}
      </HeaderLayout>;
  }
  return <MemberContent formPath={formPath} />;
};
const Content = ({
  onClose,
  formPath
}) => {
  const isTabletDown = useDeviceType('isTabletDown');
  useEffect(() => {
    if (isTabletDown) {
      onClose();
    }
  });
  if (isTabletDown) {
    return null;
  }
  return <Container data-component="date-specific-hours-modal">
      <CustomSheet>
        <HeaderWrapper>
          <Header>
            <HeaderContent formPath={formPath} />
            <IconButton onClick={onClose} aria-label={I18n.t('publisher.action.close')} size="small">
              <CloseIcon />
            </IconButton>
          </Header>
        </HeaderWrapper>
        <ViewContainer>
          <AvailabilityCalendar formPath={formPath} />
        </ViewContainer>
        <Footer onClose={onClose} formPath={formPath} />
      </CustomSheet>
    </Container>;
};

// Size-based breakpoints for UiConfig - automatically generates named queries
// like isPhone, isTabletDown, isDesktopUp for use with useDeviceType()
const CALENDAR_CUSTOM_BREAKPOINTS = {
  small: 500,
  medium: 800,
  large: 1000,
  xLarge: 1500
};
export const AvailabilityCalendarModal = ({
  onClose,
  formPath
}) => <UiConfig breakpoints={CALENDAR_CUSTOM_BREAKPOINTS}>
    <Content onClose={onClose} formPath={formPath} />
  </UiConfig>;

require("./availability_calendar_modal.wyw-in-js.css!=!../../../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./availability_calendar_modal.js");